<div class="d-flex justify-content-center align-items-center vh-100">
  <nz-result nzStatus="403" [nzTitle]="isCustomerEnabled ? MESSAGES.unauthorizedAppAccessTitle : MESSAGES.unauthorizedDisabledCustomerTitle">
    <div nz-result-extra>
      <button nz-button nzType="primary" nzSize="large" class="px-5" (click)="goToLogin()">Return to Login</button>
    </div>
  </nz-result>
</div>
